// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Refer.module.css";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";

// import { BsWhatsapp } from "react-icons/bs";
// import { BsChevronDown } from 'react-icons/bs';
// import { BsPerson } from 'react-icons/bs';
// import { BsCash } from 'react-icons/bs';

// import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
// import CopyToClipboard from "react-copy-to-clipboard";
// import { FaTelegramPlane } from "react-icons/fa";
// import { FiCopy } from "react-icons/fi";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);
//   const theme = localStorage.getItem('theme')


//   const addsetting = localStorage.getItem("sitSetting");
//   const addCaseSetting = JSON.parse(addsetting);

//   const [cardData, setGame] = useState([]);

//   const copyCode = (e) => {
//     navigator.clipboard.writeText(user.referral_code);

//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referral Code Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   const copyLink = (e) => {
//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referal Link Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   if (user === undefined) {
//     return null;
//   }

//   const referralText = `Hi Friends, Play prince Ludo.in Ludo and earn 10000 daily. Download Indian App prince Ludo.in
//   बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
//    दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा

//     NK ADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
//     100% भरोसेमंद प्लेटफार्म । 24 hours support https://prince Ludo.in/login/${user.referral_code}

//     Your ReferralCode is -${user.referral_code}.`


//   // language 


//   const translations = {
//     hi: {
//       referral: 'आपकी रेफरल कमाई',
//       referPerson: 'आमंत्रित किये दोस्त | ',
//       referEarn: 'रेफरल कमाई  ',
//       referCode: 'रेफरल कोड ',
//     },
//     en: {
//       referral: 'Your Referral Earnings',
//       referPerson: 'Referred Players',
//       referEarn: 'Referral Earning',
//       referCode: 'Referral Code',
//     },
//   };

//   // change theme 

//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? 'black' : 'black',
//   };
//   const styles1 = {
//     color: theme === 'light' ? 'black' : 'white',
//   };


//   return (
//     <>
//       {/* <Header user={user} /> */}
//       <div style={styles}>
//         <div
//           className="leftContainer mt-5 pt-5"
//           style={{ ...styles, height: "100%" }}
//         >
//           <section className="referUnique">

//             {/* NEW STYLE INTRO CARD */}
//             <div className="introRibbonCard">
//               <div className="ribbonBar"></div>

//               <div className="ribbonContent">
//                 <img src="/images/refer.png" className="refer_icon" />
//                 <div>
//                   <h3>Refer & Earn</h3>
//                   <p>You can earn more more real money doing refer to your friends</p>
//                 </div>
//               </div>
//             </div>

//             {/* REFERRAL CODE CARD */}
//             <div className="codeLayerCard">
//               <label>Your Referral Code</label>

//               <div className="codeRow">
//                 <strong>{user.referral_code}</strong>

//                 <button className="copySmall" onClick={(e) => copyCode(e)}>
//                   Copy
//                 </button>
//               </div>
//             </div>
//             <div className="whatsapp_share_btn">
//               <a
//                 href={`whatsapp://send?text=Play%20On%20prince Ludo.in%20%0A%E0%A4%B2%E0%A5%82%E0%A4%A1%E0%A5%8B%20%E0%A4%96%E0%A5%87%E0%A4%B2%20%E0%A4%95%E0%A4%B0%20%E0%A4%AF%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%95%E0%A5%87%20%E0%A4%AA%E0%A5%88%E0%A4%B8%E0%A4%BE%20%E0%A4%9C%E0%A5%80%E0%A4%A4%E0%A5%8B%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%88%E0%A5%A4%0A%0AAuto%20Deposit%20%26%20Auto%20Withdrawal%0A%0AInstant%20Withdrawal%20Via%20UPI%2FBank%2FWallet%20%0A%0ACommission%205%25%20Only%0AReferral%20commission%203%25%0A%0A100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%0A%0A24x7%20Live%20Chat%20%26%20Call%20Support%0A%0Ahttps%3A%2F%2Fprince Ludo.inludo.com%2Flogin%2F${user.referral_code}`}



//               >
//                 <BsWhatsapp className="icons" />
//                 <span class="ml-2">Whatsapp</span>
//               </a>
//             </div>

//             {/* STATS */}
//             <div className="statsFlex">

//               <div className="statLayerCard">
//                 <div>
//                   <h4>{user.referral_user?.length}</h4>
//                   <p>People Referred</p>
//                 </div>
//                 <img src="/images/trophy.png" className="stat_icon" />
//               </div>

//               <div className="statLayerCard">
//                 <div>
//                   <h4>₹{user.referral_earning}</h4>
//                   <p>Total Earned</p>
//                 </div>
//                 <img src="/images/monney.png" className="stat_icon" />
//               </div>

//             </div>

//           </section>


//         </div>
//       </div>
//     </>
//   );
// };

// export default Refer;
import React, { useContext } from "react";
import Swal from "sweetalert2";

import {
  BsWhatsapp,
  BsGiftFill,
  BsPeopleFill,
  BsWallet2,
  BsPercent,
  BsArrowRight
} from "react-icons/bs";

import {
  FiCopy,
  FiShare2,
  FiUsers,
  FiDollarSign
} from "react-icons/fi";

import { LanguageContext } from "../Components/LanguageContext";


const Refer = ({ user }) => {

  const { language } = useContext(LanguageContext);

  if (!user) return null;


  /* =========================================
     COPY REFERRAL CODE
  ========================================== */

  const copyCode = () => {

    navigator.clipboard.writeText(user.referral_code);

    Swal.fire({
      icon: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1000,
    });

  };


  /* =========================================
     SHARE MESSAGE
  ========================================== */

  const shareText = `🔥 Hello Dost 👋

Apni Site prince Ludo par Game Khelo aur Daily Paisa Jeeto 💸

🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

👉 Join Now:
https://princeludo.com/login/${user.referral_code}

🎯 Referral Code: ${user.referral_code}`;


  return (

    <div className="prince_refer_page">

      <div className="prince_refer_main">


        {/* =================================================
            HERO
        ================================================= */}

        <section className="prince_refer_hero">

          <div className="prince_refer_glow prince_refer_glow_one"></div>

          <div className="prince_refer_glow prince_refer_glow_two"></div>


          <div className="prince_refer_hero_content">

            <div className="prince_refer_gift_3d">

              <div className="prince_refer_gift_inner">
                <BsGiftFill />
              </div>

              <span></span>

            </div>


            <div className="prince_refer_hero_text">

              <small>
                PRINCE LUDO REWARDS
              </small>

              <h1>
                INVITE & <strong>EARN</strong>
              </h1>

              <p>
                Invite your friends and earn rewards together
              </p>

            </div>

          </div>


          <div className="prince_refer_percentage">

            <BsPercent />

            <div>
              <strong>3%</strong>
              <span>COMMISSION</span>
            </div>

          </div>


          <div className="prince_refer_hero_footer">

            <span></span>

            <div>
              <BsGiftFill />
              EXCLUSIVE REFERRAL REWARDS
            </div>

            <span></span>

          </div>

        </section>


        {/* =================================================
            REWARD CARD
        ================================================= */}

        <section className="prince_reward_card">

          <div className="prince_reward_bg_circle"></div>

          <div className="prince_reward_header">

            <div className="prince_reward_icon">
              <BsGiftFill />
            </div>

            <div>

              <small>
                YOUR REWARD PROGRAM
              </small>

              <h2>
                Exclusive Rewards
              </h2>

            </div>

          </div>


          <p className="prince_reward_description">
            Share your referral code with friends and earn
            commission whenever they join and play.
          </p>


          {/* Reward Highlight */}

          <div className="prince_reward_highlight">

            <div className="prince_reward_highlight_icon">
              <BsPercent />
            </div>

            <div>

              <strong>
                3% Commission
              </strong>

              <span>
                Earn from every successful referral
              </span>

            </div>

            <div className="prince_reward_check">
              ✓
            </div>

          </div>

        </section>


        {/* =================================================
            STATS
        ================================================= */}

        <div className="prince_refer_section_title">

          <div>
            <small>YOUR REFERRAL JOURNEY</small>
            <h2>Referral Overview</h2>
          </div>

          <span>✦</span>

        </div>


        <section className="prince_refer_stats">


          {/* REFERRALS */}

          <div className="prince_refer_stat prince_referral_stat">

            <div className="prince_refer_stat_top">

              <div className="prince_refer_stat_icon">
                <FiUsers />
              </div>

              <span>
                USERS
              </span>

            </div>

            <div className="prince_refer_stat_data">

              <small>
                Total Referrals
              </small>

              <strong>
                {user.referral_user?.length || 0}
              </strong>

              <span>
                FRIENDS JOINED
              </span>

            </div>

          </div>


          {/* EARNINGS */}

          <div className="prince_refer_stat prince_earning_stat">

            <div className="prince_refer_stat_top">

              <div className="prince_refer_stat_icon">
                <FiDollarSign />
              </div>

              <span>
                EARNINGS
              </span>

            </div>

            <div className="prince_refer_stat_data">

              <small>
                Total Earnings
              </small>

              <strong>
                ₹{user.referral_earning || 0}
              </strong>

              <span>
                REFERRAL INCOME
              </span>

            </div>

          </div>

        </section>


        {/* =================================================
            REFERRAL CODE
        ================================================= */}

        <section className="prince_code_card">

          <div className="prince_code_card_top">

            <div className="prince_code_title">

              <div className="prince_code_icon">
                <BsGiftFill />
              </div>

              <div>

                <small>
                  YOUR UNIQUE CODE
                </small>

                <h2>
                  Referral Code
                </h2>

              </div>

            </div>

            <FiShare2 className="prince_code_share" />

          </div>


          <div className="prince_code_box">

            <div className="prince_code_value">

              <span>
                {user.referral_code}
              </span>

            </div>


            <button
              type="button"
              className="prince_copy_button"
              onClick={copyCode}
            >

              <FiCopy />

              <span>
                Copy
              </span>

            </button>

          </div>


          <p className="prince_code_hint">
            Copy your code and share it with your friends.
          </p>

        </section>


        {/* =================================================
            INVITE CTA
        ================================================= */}

        <a
          href={`whatsapp://send?text=${encodeURIComponent(shareText)}`}
          className="prince_invite_button"
        >

          <div className="prince_invite_icon">
            <BsWhatsapp />
          </div>

          <div className="prince_invite_text">

            <strong>
              Invite Friends
            </strong>

            <span>
              Share your referral code on WhatsApp
            </span>

          </div>

          <div className="prince_invite_arrow">
            <BsArrowRight />
          </div>

        </a>


        {/* =================================================
            BOTTOM INFO
        ================================================= */}

        <section className="prince_refer_info">

          <div className="prince_refer_info_icon">
            <BsPeopleFill />
          </div>

          <div>

            <strong>
              Share More, Earn More
            </strong>

            <span>
              Invite your friends to Prince Ludo and grow
              your referral rewards.
            </span>

          </div>

          <BsWallet2 className="prince_refer_wallet" />

        </section>


        {/* =================================================
            FOOTER
        ================================================= */}

        <div className="prince_refer_footer">

          <span></span>

          <div>
            ✦ PRINCE LUDO ✦
          </div>

          <span></span>

        </div>


      </div>

    </div>

  );
};

export default Refer;